import { type FC, useMemo } from "react";
import { Button, DialogContent, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormBuilder } from "@/shared/components/Form";
import { DialogHeader } from "@/shared/components";
import {
  getCountryAccessFormSchema,
  type CountryAccessFormValues,
} from "../model";

const FORM_ID = "country-access-form";

interface CountryAccessFormProps {
  initialValues: CountryAccessFormValues;
  onSubmit: (values: CountryAccessFormValues) => Promise<void>;
  onClose: () => void;
  title: string;
  loading?: boolean;
}

export const CountryAccessForm: FC<CountryAccessFormProps> = ({
  initialValues,
  onSubmit,
  onClose,
  title,
  loading = false,
}) => {
  const { t } = useTranslation();

  const schema = useMemo(() => getCountryAccessFormSchema(t), [t]);

  const handleSubmit = async (values: Record<string, unknown>) => {
    await onSubmit(values as unknown as CountryAccessFormValues);
  };

  return (
    <>
      <DialogHeader
        title={title}
        actions={
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              type="submit"
              form={FORM_ID}
              disabled={loading}
            >
              {t("common.actions.save")}
            </Button>
          </Stack>
        }
        onClose={onClose}
        loading={loading}
      />

      <DialogContent sx={{ p: 1 }}>
        <FormBuilder
          formId={FORM_ID}
          schema={schema}
          initialValues={initialValues}
          onSubmit={handleSubmit}
          disabled={loading}
          submitButton={false}
          resetButton={false}
        />
      </DialogContent>
    </>
  );
};
